import * as yup from 'yup'
import i18n from '../../i18n/i18n'

export const signInSchema = yup
  .object({
    email: yup.string().email().required(),
    password: yup
      .string()
      .required()
      .min(
        8,
        i18n.t('form.errors.minLength', {
          minLength: '8',
        })
      ),
  })
  .required()
